import { Form, Offcanvas, Button } from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";

const ConfigurePlateformRestriction = ({
  show,
  hide,
  title,
  widgetPlateformRestrictionSettings,
  setWidgetPlateformRestrictionSettings,
  toggleWidgetPlateformRestrictionSettings,
  initialPlateformRestrictionSettings
}) => {
  const DEVICE_OPTIONS = [
    { label: "Desktop", value: "desktop" },
    { label: "Mobile", value: "mobile" },
  ];

  const handleMultiSelectChange = (type, selectedList) => {
    setWidgetPlateformRestrictionSettings((prev) => ({
      ...prev,
      [type]: [...new Set(selectedList.map((item) => item.value))],
    }));
  };

  const mapValuesToLabels = (values) => {
    return DEVICE_OPTIONS.filter((opt) =>
      values.includes(opt.value)
    );
  };

  const filterOptions = (type) => {
    return DEVICE_OPTIONS.filter(
      (opt) =>
        !widgetPlateformRestrictionSettings?.[type]?.includes(opt.value)
    );
  };

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <h6>Plateform Restriction</h6>
          <p style={{ fontSize: 12 }}>
            By default, channel is available to all platforms. You can restrict your channel by allowing or denying specific platforms
          </p>
          <Form.Check
            type="switch"
            id="show-toggle"
            style={{ fontSize: 12 }}
            label="Show widget platform restriction"
            checked={widgetPlateformRestrictionSettings?.showEnabled}
            onChange={(e) =>
              toggleWidgetPlateformRestrictionSettings("showEnabled", e.target.checked)
            }
            className="mb-2"
          />
          {widgetPlateformRestrictionSettings?.showEnabled && (
            <div className="mb-3">
              <Multiselect
                displayValue="label"
                placeholder="Select Device"
                options={filterOptions("showDevices")}
                selectedValues={mapValuesToLabels(
                  widgetPlateformRestrictionSettings.showDevices
                )}
                onSelect={(list) =>
                  handleMultiSelectChange("showDevices", list)
                }
                onRemove={(list) =>
                  handleMultiSelectChange("showDevices", list)
                }
              />
            </div>
          )}
          <Form.Check
            type="switch"
            id="hide-toggle"
            style={{ fontSize: 12 }}
            label="Hide widget platform restriction"
            checked={widgetPlateformRestrictionSettings?.hideEnabled}
            onChange={(e) =>
              toggleWidgetPlateformRestrictionSettings("hideEnabled", e.target.checked)
            }
            className="mb-2"
          />
          {widgetPlateformRestrictionSettings?.hideEnabled && (
            <Multiselect
              displayValue="label"
              placeholder="Select Device"
              options={filterOptions("hideDevices")}
              selectedValues={mapValuesToLabels(
                widgetPlateformRestrictionSettings.hideDevices
              )}
              onSelect={(list) =>
                handleMultiSelectChange("hideDevices", list)
              }
              onRemove={(list) =>
                handleMultiSelectChange("hideDevices", list)
              }
            />
          )}
          {widgetPlateformRestrictionSettings?.plateformRestriction &&
            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button
                size="sm"
                variant="outline-danger"
                onClick={() => setWidgetPlateformRestrictionSettings(initialPlateformRestrictionSettings)}
              >
                Reset
              </Button>
            </div>
          }
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ConfigurePlateformRestriction;
